import { Col, Row } from '@elotech/components';
import { ChangeEvent } from 'react';
import { FormGroup } from 'react-bootstrap';

import { InlineButton } from '../inline-button';
import { Label } from '../label';

type Props = {
  name: string;
  fileName?: string;
  label: string;
  size: number;
  onChange: (event: ChangeEvent<any>) => void;
  onRemove?: () => void;
  onDownload?: () => void;
  onView?: () => void;
};

const InputFile = ({
  name,
  fileName,
  label,
  size,
  onChange,
  onRemove,
  onDownload,
  onView
}: Props) => {
  const hasSomeButton = !!onRemove || !!onDownload || !!onView;
  const descricaoArquivo = fileName ? `arquivo ${fileName}` : 'arquivo anexado';
  const mensagemAnexo = 'Clique aqui ou arraste para anexar o arquivo';
  return (
    <>
      <Col md={size}>
        <FormGroup>
          <Label>{label}</Label>

          <Row>
            <Col md={hasSomeButton ? 9 : 12}>
              <div className="file-uploader">
                <input
                  type="file"
                  name={name}
                  className="file-uploader-input"
                  onChange={event => onChange(event)}
                  title={mensagemAnexo}
                  aria-label={
                    fileName
                      ? `${label}: ${fileName}`
                      : `${label}: ${mensagemAnexo}`
                  }
                />

                <label
                  className="input"
                  data-title={`${fileName ? fileName : mensagemAnexo}`}
                />
                <div className="file-uploader-icon" />
              </div>
            </Col>
            {hasSomeButton && (
              <Col md={3}>
                {!!onDownload && (
                  <InlineButton
                    label="Baixar"
                    aria-label={`Baixar ${descricaoArquivo}`}
                    icon="fa fa-download"
                    onClick={onDownload}
                  />
                )}
                {!!onView && (
                  <InlineButton
                    label="Visualizar"
                    aria-label={`Visualizar ${descricaoArquivo}`}
                    icon="fa fa-eye"
                    onClick={onView}
                  />
                )}
                {!!onRemove && (
                  <InlineButton
                    label="Limpar"
                    aria-label={`Limpar ${descricaoArquivo}`}
                    icon="fa fa-times"
                    onClick={onRemove}
                  />
                )}
              </Col>
            )}
          </Row>
        </FormGroup>
      </Col>
    </>
  );
};

export default InputFile;
